import { createContext } from 'react'

export const Context = createContext({
  setIsWide: () => {},
  isWide: false,
  setZeroPadding: () => {},
  zeroPadding: false,
})

export const { Provider } = Context
